import React, { Component } from "react";
import AuthStateProvider from "./AuthStateProvider";

export default class AppStateProvider extends Component {
  render() {
    return <AuthStateProvider>{this.props.children}</AuthStateProvider>;
  }
}
